
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"currentColor","stroke":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22.5 7.5V18L12 22.5 1.5 18V7.5L12 12l10.5-4.5zM12 22.5V12M7.5 4.929 1.5 7.5m15-2.571 6 2.571M7.5 3a4.5 1.5 0 1 0 9 0 4.5 1.5 0 1 0-9 0Z","fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M7.5 3v3c0 .828 2.015 1.5 4.5 1.5s4.5-.672 4.5-1.5V3","fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}})])
          )
        }
      }
    